"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.state = exports.get = void 0;
function get(s) {
    return s.me.user;
}
exports.get = get;
function state(s) {
    const { errorMessage, isProcessing } = s.me;
    return { errorMessage, isProcessing };
}
exports.state = state;
//# sourceMappingURL=selectors.js.map